import { connect } from "react-redux";
import equal from 'fast-deep-equal';

var BraveCheckbox = require("components/utility/BraveCheckbox");
var Glyphicon = require("components/utility/icons/Glyphicon");
var DropDownOptions = require("components/utility/DropDownOptions");
var HelpSectionLink = require("components/utility/HelpSectionLink");
var EditableGoals = require("components/org/roster/EditableGoals");
var ToggleMultiselect = require("components/utility/inputs/ToggleMultiselect");
var Spinner = require("components/utility/Spinner");
var PaywallModal = require("components/users/teachers/PaywallModal");

var StudentMetrics = require("lib/data/StudentMetrics");
var Features = require("lib/account/Features");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");
var UIActions = require("lib/actions/UIActions");
var CurrentUser = require("lib/account/CurrentUser");

@connect(
	(state, props) => {
		var downProps = {
			currentAdmin: RosterSelectors.admin({ state, id: CurrentUser.get().id }),
			teachers: RosterSelectors.admins({
				state, filters: { role: "teacherRole" }
			}),
			isLoadingStudents: RosterSelectors.isLoadingStudentLists({ state })
		}


		// if any student does not have a primary, or if their primary is inactive.
		var studentListLinkProblem = _.some(props.studentList.students, (student)=>{
			return (!student.student_list_ids.primary || !student.student_list_ids.active.includes(student.student_list_ids.primary))
		})

		downProps.studentListLinkProblem = studentListLinkProblem

		return downProps
	}, 
	(dispatch, props) => ({
		updateStudentList: (update) => {
			const promises = [];
			if (update.prefs) {
				promises.push(dispatch(RosterActions.updateStudentListPrefs({
					update: update.prefs,
					studentListID: props.studentList.id,
					resetStudents: true
				})));

				update = _.omit(update, "prefs");
			}

			if (!_.isEmpty(update)) {
				promises.push(dispatch(RosterActions.updateStudentList({
					id: props.studentList.id, update
				})));
			}

			return Promise.all(promises);
		},

		updateTeacherOrgIDs: (teacher, orgIDs) => {
			return dispatch(RosterActions.updateAdmin({
				id: teacher.id,
				update: {
					org_ids: orgIDs
				}
			}))
		},

		archiveStudentList: () => {
			return dispatch(RosterActions.archiveStudentList({
				id: props.studentList.id
			}));
		},

		openZpdPaywall: () =>
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.CLOZE_ASSESSMENTS }))
	})
)
class RosterStudentList extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = this.getInitialState(props);
	}

	///////// HELPERS /////////

	getInitialState(props) {
		props = props || this.props;

		if (props.studentList.id !== 0) {
			return {
				overrides: {},
				teachersSelected: this.teachersSelectedFromProps(props),
				savingChanges: false,
				extraFormHeight: props.studentList.prefs ? this.extraHeightNeeded(props.studentList.prefs.expectations_time_period) : false
			}
		} else {
			return {}
		}
	}

	extraHeightNeeded(val) {
		return (val === $wr.Constants.PERIODS.QUARTER || val === $wr.Constants.PERIODS.TRIMESTER)
	}

	teachersSelectedFromProps(props) {
		props = props || this.props;

		const slID = props.studentList.id;

		var selected = {};

		_.each(props.teachers, teacher => {
			if (teacher.org_ids) {
				if (teacher.org_ids.student_lists.primary.includes(slID)) {
					selected[teacher.id] = "primary";
				} else if (teacher.org_ids.student_lists.sub.includes(slID)) {
					selected[teacher.id] = "sub";
				}
			}
		})

		return selected;
	}

	prefs() {
		return this.props.studentList.prefs;
	}

	realStudentList() {
		return this.props.studentList && this.props.studentList.id != 0
	}

	changeGoalsConfirmationNeeded() {
		var overrides = this.state.overrides
		if (overrides && overrides.prefs) {
			return _.keys(overrides.prefs).some(metric => _.includes(METRICS_TO_CONFIRM, metric))
		} else {
			return false
		}
	}

	changeGradeLevelConfirmationNeeded() {
		var overrides = this.state.overrides
		return overrides && overrides.grade_level
	}

	hasCleverUser() {
		return this.props.currentAdmin && this.props.currentAdmin.clever_user ? true : false
	}

	///////// STUDENT LIST GETTERS /////////

	formStudentList() {
		return {
			...this.props.studentList,
			...this.state.overrides,
			prefs: {
				...this.prefs(),
				...this.state.overrides.prefs
			}
		};
	}

	///////// STATE MANIPULATORS /////////

	editStudentListForm(key, val) {
		this.setState({
			overrides: { ...this.state.overrides, [key]: val }
		})
	}

	editStudentListFormPrefs(change, callback) {

		if (_.includes(_.keys(change), 'expectations_time_period')) {
			var extraFormHeight = this.extraHeightNeeded(change['expectations_time_period'])
		} else {
			var extraFormHeight = this.state.extraFormHeight
		}

		if (callback) {
			this.setState({
				overrides: {
					...this.state.overrides,
					prefs: {
						...this.state.overrides.prefs,
						...change
					}
				},
				extraFormHeight: extraFormHeight
			}, callback)
		} else {
			this.setState({
				overrides: {
					...this.state.overrides,
					prefs: {
						...this.state.overrides.prefs,
						...change
					}
				},
				extraFormHeight: extraFormHeight
			})
		}
	}

	editSelectedStudents(selection) {
		if (!this.hasCleverUser()) {
			this.setState({ teachersSelected: selection })
		}
	}

	///////// DATABASE MANIPULATORS /////////

	onArchive(e) {
		$wr.nope(e);
		if (confirm('Are you sure you want to delete this class? This will also delete students who are ONLY in this class. This will NOT delete any students who are in multiple classes.')) {
			this.props.archiveStudentList()
			var title = "Class Archived"
			var text = "You have archived this class. However, no class is left behind."

			window.wrNotifications.triggerDropDownNotification({
				title: title, text: text, icon: "ok-circle"
			}, 4000);
		}
	}

	saveChanges(e) {
		$wr.nope(e);

		this.setState({ savingChanges: true })

		let promises = [];

		if (!_.isEmpty(this.state.overrides)) {
			if (this.changeGoalsConfirmationNeeded()) {
				if (confirm("Are you sure you want to edit the class goals? This will override all student goals in this class.")) {
					promises.push(this.props.updateStudentList(this.state.overrides));
				}
			} else if (this.changeGradeLevelConfirmationNeeded()) {
				if (confirm("Are you sure you want to edit the class grade level? This will override the grade levels for all students in this class.")) {
					promises.push(this.props.updateStudentList(this.state.overrides));
				}
			} else {
				promises.push(this.props.updateStudentList(this.state.overrides));
			}
		}

		// Note from Greg: This is not the ideal way. Ideally, we'd accomplish
		// This by posting the info to student lists. This way might leave
		// a student list without a primary admins (or with two) if a call fails.
		// However, I was somewhat boxed into this by earlier decisions on how
		// to represent teacher <-> studentList relations in redux state

		const originalTeachersSelected = this.teachersSelectedFromProps();
		const slID = this.props.studentList.id;

		_.each(this.props.teachers, teacher => {
			if (originalTeachersSelected[teacher.id] !== this.state.teachersSelected[teacher.id]) {
				let newOrgIDs;
				if (!this.state.teachersSelected[teacher.id]) {
					// Remove this studentList ID from the teacher
					newOrgIDs = {
						...teacher.org_ids, // keep other org types
						student_lists: {
							primary: _.without(teacher.org_ids.student_lists.primary, slID),
							sub: _.without(teacher.org_ids.student_lists.sub, slID),
							all: _.without(teacher.org_ids.student_lists.all, slID)
						}
					}
				} else if (this.state.teachersSelected[teacher.id] === "sub") {
					// Add as sub, remove from primary if set
					newOrgIDs = {
						...teacher.org_ids, // keep other org types
						student_lists: {
							primary: _.without(teacher.org_ids.student_lists.primary, slID),
							sub: _.union(teacher.org_ids.student_lists.sub, [slID]),
							all: _.union(teacher.org_ids.student_lists.all, [slID])
						}
					}
				} else if (this.state.teachersSelected[teacher.id] === "primary") {
					// Add as primary, remove from sub if set
					newOrgIDs = {
						...teacher.org_ids, // keep other org types
						student_lists: {
							primary: _.union(teacher.org_ids.student_lists.primary, [slID]),
							sub: _.without(teacher.org_ids.student_lists.sub, slID),
							all: _.union(teacher.org_ids.student_lists.all, [slID])
						}
					}
				}

				if (newOrgIDs) {
					promises.push(this.props.updateTeacherOrgIDs(teacher, newOrgIDs));
				}
			}
		})

		Promise.all(promises).then(() => {
			this.setState(this.getInitialState());
			this.props.fetchStudents()
			CurrentUser.fetchCurrentUserData();
			
			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", icon: "ok-sign"
			}, 4000);
		}).catch(() => {
			this.setState({ savingChanges: false })
			window.wrNotifications.triggerDropDownNotification({
				title: "Oops!", text: "Something went wrong and the student list was not edited",
				type: "error", icon: "remove"
			}, 4000);
		})
	}

	///////// RENDER METHODS /////////

	triggerRLDPaywall() {
		this.props.openZpdPaywall();
	}

	renderTeacherSelector() {
		var studentList = this.formStudentList();

		if (this.hasCleverUser()) {
			var disableClass = "disableEvents"			
			var topContent = (
				<div>
					A filled star is a primary teacher.<br />
					Empty stars are secondary teachers.{" "}
					<HelpSectionLink featureName="Primary & Secondary Classes" linkSuffix="360054128371" iconOnly />
				</div>
			)
		} else {
			var topContent = (
				<div>
					Click to select the primary admin.<br />
					Hold shift & click to set a subadmin.{" "}
					<HelpSectionLink featureName="Primary & Secondary Classes" linkSuffix="360054128371" iconOnly />
				</div>
			)
		}

		const toggles = [
			{
				key: "primary",
				icon: "star",
				select: ToggleMultiselect.SELECT_LEFT_CLICK,
				primary: true,
				singleton: true
			}, {
				key: "sub",
				icon: "star-empty",
				select: ToggleMultiselect.SELECT_LEFT_SHIFT_CLICK,
			}
		]

		var options = this.props.teachers.map(x => ({
			key: x.id, text: `${x.first_name} ${x.last_name}`
		}));

		return (
			<ToggleMultiselect className={"classSelector " + disableClass} dropdownDisplay="link"
				topContent={topContent}
				selected={this.state.teachersSelected}
				toggles={toggles}
				options={options}
				defaultDisplayText={'Select Student List(s)'}
				onChange={selection => this.editSelectedStudents(selection)} />
		)
	}
	buildPassPhraseSection() {
		if (this.props.currentAdmin.clever_user) { return }

		if (this.props.isLoadingStudents) {
			var classCodeValue = (<Spinner scale={0.5} className="classCodeSpinner" />)
		} else if (this.props.studentList.passphrase){
			var classCodeValue = (<input readOnly value={this.props.studentList.passphrase || ""} />)
		} else {
			var addClasscode = (e) => {
				$wr.nope(e)
				this.props.updateStudentList({"add_passphrase": true}).then(res=>{
					this.props.resetStudentLists()
				})
			}
			var classCodeValue = (<a onClick={addClasscode} className="classCodeLink">Add Class Code</a>)
		}

		return (
			<label className="inputPair">
				<span className="text">
					Class Code{" "}
					<span className='helpSectionContainer'>
						<HelpSectionLink featureName="Class Codes" linkSuffix="360001605011" iconOnly={true} />
					</span>
				</span>
				{classCodeValue}
			</label>
		)
	}

	// these attributes are not editable by Clever users
	buildStaticInfoSection(studentList) {
		var gradeInput = (
			<label className="inputPair">
				<span className="text">
					Grade
				</span>
				<span>{studentList.grade_level}</span>
			</label>
		)

		var teachersInput = (
			<label className="inputPair">
				<span className="text">Teachers</span>
				{this.renderTeacherSelector()}
			</label>
		)

		return { gradeInput, teachersInput }
	}

	// make editable for non-Clever users
	buildEditableInfoSection(studentList) {
		var gradeInput = (
			<label className="inputPair">
				<span className="text">
					Grade
				</span>
				<select type="text" value={studentList.grade_level}
					id={ `select-grade-sl${this.props.slIndex}` }
					onChange={(e) => this.editStudentListForm("grade_level", e.target.value)}>

					{DropDownOptions.Select.GradeLevels()}
				</select>
			</label>
		)

		var teachersInput = (
			<label className="inputPair">
				<span className="text">Teachers</span>
				{this.renderTeacherSelector()}
			</label>
		)

		var classCodeInput = this.buildPassPhraseSection()
		return { gradeInput, teachersInput, classCodeInput }
	}

	// Class names can be edited by all users
	nameInput(studentList) {
		return (
			<label className="inputPair">
				<span className="text">
					Name
				</span>
				<input type="text" value={studentList.name} data-lpignore="true"
					id={`input-slName-sl${this.props.slIndex}`}
					onChange={(e) => this.editStudentListForm('name', e.target.value)} />
			</label>	
		)
	}

	// disclaimer that digests need to be recalculated overnight.
	renderDisclaimer(){
		if (this.state.overrides['prefs'] && this.props.expanded){
			if (this.state.overrides['prefs']['expectations_time_period'] || this.state.overrides['prefs']['expectations_time_period_starts']){
				return (
					<div className="disclaimer">
						<p>Note: Changes to data settings are recalculated overnight. This change will be reflected on your data pages <i>tomorrow</i>.</p> 
					</div>
				)
			}
		}
	}


	renderInfoSection() {
		var studentList = this.formStudentList();

		if (this.state.savingChanges) {
			var buttonSection = (<Spinner scale={1} className="btnSectionSpinner" />)
		} else {
			var archiveBtn = this.hasCleverUser() ? '' : <a className="btn-link archiveClassBtn" type="button" onClick={this.onArchive}>Archive Class</a>
			var buttonSection = (
				<div className="buttons">
					<div><button className="btn btn-link buttonPrimary saveButton" type="submit">Save</button></div>
					{archiveBtn}
				</div>
			);
		}

		var openSectionClass = this.props.expanded ? this.props.openSectionClass : 'drawerClosed'
		var extraFormHeightClass = this.state.extraFormHeight ? ' extraHeight' : ''

		if (this.hasCleverUser()) {
			var { gradeInput, teachersInput } = this.buildStaticInfoSection(studentList)
		} else {
			var { gradeInput, teachersInput, classCodeInput } = this.buildEditableInfoSection(studentList)
		}

		return (
			<form className={"editSection " + openSectionClass + extraFormHeightClass} onSubmit={this.saveChanges}>
				<div className="firstCol">
					<div className="studentSectionHeader">Class Information</div>
					{this.nameInput(studentList)}
					{gradeInput}
					{teachersInput}

					<label className="inputPair">
						<span className="text">
							Owl Shop
						</span>
						<select type="text" value={studentList.prefs.shop_opening_time}
							id={`select-owlShopHours-sl${this.props.slIndex}`}
							onChange={(e) => this.editStudentListFormPrefs({ "shop_opening_time": e.target.value })}>

							{DropDownOptions.Select.OwlShopOpeningTimes()}
						</select>
					</label>
					
					<label className="inputPair">
						<span className="text">Quizzes</span>
						<select type="text" value={studentList.prefs.quiz_close_time || "Never close"}
							id={`select-quizCloseTime-sl${this.props.slIndex}`}
							onChange={(e) => this.editStudentListFormPrefs({ "quiz_close_time": e.target.value })}>
							{DropDownOptions.Select.QuizClosingTimes()}
						</select>
					</label>
					
					{classCodeInput}
				</div>

				<div className="secondCol">

					<EditableGoals indexKey={`sl${this.props.slIndex}`} prefs={studentList.prefs} gradeLevel={studentList.grade_level.toString()} onEditPrefs={this.editStudentListFormPrefs} quiz supplemental />

				</div>

				<div className="thirdCol">

					<EditableGoals indexKey={`sl${this.props.slIndex}`} prefs={studentList.prefs} gradeLevel={studentList.grade_level.toString()} onEditPrefs={this.editStudentListFormPrefs} periodSelector />

				</div>

				<div className="fourthCol">

					<div className="hideBtn">
						<a className="btn btn-link" onClick={this.props.toggleFormStatus.bind(this, studentList.id)}>Hide <Glyphicon icon={'menu-up'} /></a>
					</div>

				</div>

				<div className="btnContainer">
					{buttonSection}
				</div>
			</form>
		);
	}

	componentDidUpdate(prevProps) {
		if (!equal(this.props.teachers, prevProps.teachers)) // Check if it's a new teacher
		{
			this.setState({ teachersSelected: this.teachersSelectedFromProps(this.props) });
		}
	}
	isLoadingStudents() {
		if (this.props.studentList && this.props.studentList.student_ids && this.props.studentList.student_ids.length > 0) {
			if (!this.props.studentList.students || this.props.studentList.students.length != this.props.studentList.student_ids.length) {
				return true
			}
		}
		return false
	}
	render() {
		var { studentList } = this.props;

		if (this.realStudentList() && this.props.formExpanded) {
			var selectedEditSection = this.renderInfoSection();
		}
		// add school name under student list
		if (this.realStudentList() && studentList.school) {
			// truncate just in case
			var schoolName = $wr.truncate(studentList.school.name, 50)
		}

		var icon = this.props.expanded ? "menu-up" : "menu-down"

		if (this.isLoadingStudents()) {
			var loading = (
				<span>
					Loading..
				</span>
			)
		}

		if (this.props.studentListLinkProblem){
			var warning = <Glyphicon icon='exclamation-sign'/>
		}

		return (
			<div className="rosterStudentList"
				key={"studentList-" + studentList.id}
				id={`rosterStudentListHeader-sl${this.props.slIndex}`}
			>
				<div className={`nameSection studentList-${studentList.id}`}
					onClick={this.props.handleExpandStudentListSection.bind(this, studentList.id)}>
					<div className="detailSection studentListName">
						<div className="studentInfoText">
							<div className='topRow'>
								{ studentList.name }	
								{ warning }
							</div>
							<div className="schoolName">{schoolName}</div>
							{ loading }
						</div>
					</div>
					<div className="detailSection">
						<div className="menuOption"><Glyphicon icon={icon} /></div>
					</div>
				</div>
				{this.renderDisclaimer()}
				{selectedEditSection}
			</div>
		);
	}
}

var METRICS_TO_CONFIRM = ['expectations_metrics', 'expectations_time_period', 'expectations_time_period_starts', 'recall_question_count', 'sentence_starter_count']

RosterStudentList.WrappedComponent.propTypes = PageStrictPropTypes({
	// From above
	studentList: PropTypes.object,
	currentAdmin: PropTypes.object,
	selected: PropTypes.bool,
	toggleSelected: PropTypes.func,
	teachers: PropTypes.array,
	openSectionClass: PropTypes.string,
	expanded: PropTypes.bool,
	formExpanded: PropTypes.bool,
	handleExpandStudentListSection: PropTypes.func,
	toggleFormStatus: PropTypes.func,
	openZpdPaywall: PropTypes.func,
	studentListLinkProblem: PropTypes.bool,
	slIndex: PropTypes.number,

	// @connect handler
	updateStudentList: PropTypes.func,
	updateTeacherOrgIDs: PropTypes.func,
	archiveStudentList: PropTypes.func,
	fetchStudents: PropTypes.func,
	isLoadingStudents: PropTypes.bool,
	resetStudentLists: PropTypes.func,
});

module.exports = RosterStudentList;


// WEBPACK FOOTER //
// ./modules/components/org/roster/RosterStudentList.js